<template>
  <div>
    <h1>Sites</h1>
    <SitesGrid ref="sitesGrid" show-detail-button />
  </div>
</template>

<script>
import firebase from "@/firebase";
import TenseBuilder from "tense-builder";
import SitesGrid from "@/components/SitesGrid";

const tenseBuilder = new TenseBuilder();
tenseBuilder.config.separator = "-";

export default {
  components: {
    SitesGrid,
  },

  data() {
    let slugs = [];
    if (this.$route.params.slug != null) {
      slugs = tenseBuilder.parse(this.$route.params.slug);
    }
    return {
      sites: [],
      slugs,
    };
  },

  mounted() {
    this.$refs.sitesGrid.getSites();

    let query = firebase.firestore.collection("sites"); //.where('enabled', '==', true)

    const f = this.slugs.filter((x) => x.type !== "subject");
    const ands = f.filter((x) => x.mood === "and");
    const ors = f.filter((x) => x.mood === "or");

    // no puedo filtrarlo por tags creo, tengo que ir categoria a categoria
    // climate = hot, cold
    // el problema es que tendré que ir clasificando todas las palabras a sus correspondientes categorias
    // eso me hará hacer todos los datos con us categorias e irlos emparejando des de la url a la logica de las queries
    // lo más fácil será hacer el filtro y con él la estructura de datos para clasificar la url que venga o generarla también de forma sencilla

    if (ands.length !== 0) {
      query = query.where(
        "tags",
        "array-contains-any",
        ands.map((x) => x.word)
      );
    }

    if (ors.length !== 0) {
      query = query.where(
        "tags",
        "array-contains-any",
        ors.map((x) => x.word)
      );
    }

    query
      .get()
      .then((x) => {
        x.forEach((x) => {
          const site = x.data();
          site.id = x.id;
          this.sites.push(site);
        });
      })
      .catch((e) => console.error(e));
  },
};
</script>

<style></style>
